/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Grid } from '@mui/material'
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import html2canvas from "html2canvas";
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import moment from 'moment';
import { AxiosGet, AxiosPost, AxiosPostFileExcel, ResultAPI } from 'service/CommonFunction/TS_function';
import DateRangePicker from 'components/Common/ElementInForm/DateRange';
import { BtnExportExcel, BtnSearch } from 'components/Common/Button';
import MultiSelectForm from 'components/Common/ElementInForm/MultiSelectForm';
import StatusPieChart from './components/StatusPieChart';
import TypeComplaintPieChart from './components/TypeComplaintPieChart';
import TypeComplaintTimeLineChart from './components/TypeComplaintTimeLineChart';
import BAOverlapPieChart from './components/BAOverlapPieChart';
import NumberReqBarChart from './components/NumberReqBarChart';
import PieStackTypeCustomer from './components/PieStackTypeCustomer';

const SummaryStatusRequestReport = () => {

    const { BlockUI, UnBlockUI } = FnBlock_UI();

    const [optionBA, setoptionBA] = useState([] as any);
    const [optionJobType, setoptionJobType] = useState([] as any);
    const [sBA, setsBA] = useState("")
    const [ImgChart, setImgChart] = useState([] as any);
    const [nCountAllDiv, setnCountAllDiv] = useState(0)

    const [dataDiv1, setdataDiv1] = useState(null);
    const [dataDiv2, setdataDiv2] = useState([] as any);
    const [dataExistCust, setdataExistCust] = useState(null);
    const [dataPotentialCust, setdataPotentCust] = useState(null);
    const [dataDiv3, setdataDiv3] = useState([] as any);
    const [dataDiv4, setdataDiv4] = useState([] as any);
    const [dataDiv5, setdataDiv5] = useState(null) as any

    //#region  Form
    let objSchema = {
        arrBA: yupFormSchemas.stringArray("กลุ่มตลาด", { required: false }),
        arrTypeJob: yupFormSchemas.stringArray("ประเภทคำร้อง", { required: false }),
        arrDateIssue: yupFormSchemas.stringArray("วันที่แจ้ง", { required: true }),
    }

    const schema = yup.object().shape(objSchema);
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })
    //#endregion


    useEffect(() => {
        let today = new Date();
        form.setValue("arrDateIssue", [new Date(today.getFullYear(), today.getMonth(), 1), new Date(today.getFullYear(), today.getMonth(), today.getDate())])
        onGetOptionAll();
    }, [])

    const GetReportSLA = () => {
        let obj = {
            "lstBA": form.getValues("arrBA") ?? null,
            "lstJobType": form.getValues("arrTypeJob") ?? null,
            "sIssueDateStart": form.getValues("arrDateIssue")[0] ? (moment(form.getValues("arrDateIssue")[0])).format("DD/MM/YYYY") + "" : null,
            "sIssueDateEnd": form.getValues("arrDateIssue")[1] ? (moment(form.getValues("arrDateIssue")[1])).format("DD/MM/YYYY") + "" : null,
        }
        AxiosPost(`Report/GetReportSLA`, obj, (res) => {
            ResultAPI(res, null, () => {
                setdataDiv2(res.lstdata)
            })
        });
    }


    const GetDataDiv1 = () => {
        let obj = {
            "lstBA": form.getValues("arrBA") ?? null,
            "lstJobType": form.getValues("arrTypeJob") ?? null,
            "sIssueDateStart": form.getValues("arrDateIssue")[0] ? (moment(form.getValues("arrDateIssue")[0])).format("DD/MM/YYYY") + "" : null,
            "sIssueDateEnd": form.getValues("arrDateIssue")[1] ? (moment(form.getValues("arrDateIssue")[1])).format("DD/MM/YYYY") + "" : null,
        }
        AxiosPost(`Report/GetDataStatusPieChart`, obj, (res) => {
            ResultAPI(res, null, () => {
                setdataDiv1(res)
            })
        });
    }
    

    const GetDataDiv3Customer = () => {
        let obj = {
            "lstBA": form.getValues("arrBA") ?? null,
            "lstJobType": form.getValues("arrTypeJob") ?? null,
            "sIssueDateStart": form.getValues("arrDateIssue")[0] ? (moment(form.getValues("arrDateIssue")[0])).format("DD/MM/YYYY") + "" : null,
            "sIssueDateEnd": form.getValues("arrDateIssue")[1] ? (moment(form.getValues("arrDateIssue")[1])).format("DD/MM/YYYY") + "" : null,
        }
        AxiosPost(`Report/GetDataDiv3Customer`, obj, (res) => {
            ResultAPI(res, null, () => {
                setdataExistCust(res.ExistCustomer)
                setdataPotentCust(res.PotentialCustomer)
            })
        });
    }

    const GetDataDiv3 = () => {
        let obj = {
            "lstBA": form.getValues("arrBA") ?? null,
            "lstJobType": form.getValues("arrTypeJob") ?? null,
            "sIssueDateStart": form.getValues("arrDateIssue")[0] ? (moment(form.getValues("arrDateIssue")[0])).format("DD/MM/YYYY") + "" : null,
            "sIssueDateEnd": form.getValues("arrDateIssue")[1] ? (moment(form.getValues("arrDateIssue")[1])).format("DD/MM/YYYY") + "" : null,
        }
        AxiosPost(`Report/GetDataTimelineChart`, obj, (res) => {
            ResultAPI(res, null, () => {
                setdataDiv3(res.lstReturn)
            })
        });
    }

    const GetDataDiv4 = () => {
        let obj = {
            "lstBA": form.getValues("arrBA") ?? null,
            "lstJobType": form.getValues("arrTypeJob") ?? null,
            "sIssueDateStart": form.getValues("arrDateIssue")[0] ? (moment(form.getValues("arrDateIssue")[0])).format("DD/MM/YYYY") + "" : null,
            "sIssueDateEnd": form.getValues("arrDateIssue")[1] ? (moment(form.getValues("arrDateIssue")[1])).format("DD/MM/YYYY") + "" : null,
        }
        AxiosPost(`Report/GetDataOverlapChart`, obj, (res) => {
            ResultAPI(res, null, () => {
                setdataDiv4(res.lstReturn)
            })
        });
    }

    const GetDataDiv5 = () => {
        let obj = {
            "lstBA": form.getValues("arrBA") ?? null,
            "lstJobType": form.getValues("arrTypeJob") ?? null,
            "sIssueDateStart": form.getValues("arrDateIssue")[0] ? (moment(form.getValues("arrDateIssue")[0])).format("DD/MM/YYYY") + "" : null,
            "sIssueDateEnd": form.getValues("arrDateIssue")[1] ? (moment(form.getValues("arrDateIssue")[1])).format("DD/MM/YYYY") + "" : null,
        }
        AxiosPost(`Report/GetlstDataDiv5`, obj, (res) => {
            ResultAPI(res, null, () => {
                setdataDiv5(res)
            })
        });
    }

    const onGetOptionAll = async () => {
        await AxiosGet(`BAService/GetBA`, { "IsSuggestion": false }, (res) => {
            ResultAPI(res, null, () => {
                let arrOption = res.result?.data || []
                setoptionBA(arrOption)
                if (arrOption.length > 0) {
                    let arrValue = arrOption.map(item => item.value);
                    form.setValue("arrBA", arrValue)

                    if (arrOption.length === 4) {
                        setsBA("GBU")
                    }
                    else {
                        let arrBA = arrOption.map(item => item.label);
                        setsBA(arrBA.join(', '))
                    }
                }
            })
        });
        await AxiosGet(`MasterData/GetVOCJobTypeReport`, null, (res) => {
            ResultAPI(res, null, () => {
                let arrOption = res.result?.data || []
                setoptionJobType(arrOption)
                if (arrOption.length > 0) {
                    let arrValue = arrOption.map(item => item.value);
                    form.setValue("arrTypeJob", arrValue)
                }
            })
        });

        await onSearchData(false);
    }

    const onSearchData = async (isSet = true) => {
        setImgChart([]);

        BlockUI();
        let formBA = form.getValues("arrBA") || []
        if (isSet === true) {
            let arrBA = optionBA.filter(f => formBA.includes(f.value)).map(item => item.label);
            setsBA(formBA.length === 4 ? "GBU" : arrBA.join(', '))
        }

        GetDataDiv1();
        GetReportSLA();
        GetDataDiv3Customer();
        GetDataDiv3();
        GetDataDiv4();
        GetDataDiv5();
        UnBlockUI();


    };

    const onGetBase64Timeline = async () => {
        await BlockUI();
        let arrTypeJob = (form.getValues("arrTypeJob") || []);
        let arrBase64 = [] as any;
        
        if ((arrTypeJob.findIndex(f=>f === "2")) !== -1) {
            let strHTMLtimeline3 = document.getElementById("timeline_2");
            if (strHTMLtimeline3) {
                let Element = strHTMLtimeline3 as HTMLDivElement;
                let canvas = await html2canvas(Element);
                let image = canvas.toDataURL("image/png", 1.0);
                let obj = {
                    id: 32,
                    sDesc: "timeline3",
                    sName: "ข้อร้องขอ",
                    idDiv: 4,
                    imgBase64: image
                }
                arrBase64.push(obj)
            }
        }

        if ((arrTypeJob.findIndex(f=>f === "1")) !== -1) {

            let strHTMLtimeline1 = document.getElementById("timeline_1");
            if (strHTMLtimeline1) {
                let Element = strHTMLtimeline1 as HTMLDivElement;
                let canvas = await html2canvas(Element);
                let image = canvas.toDataURL("image/png", 1.0);
                let obj = {
                    id: 30,
                    sDesc: "timeline1",
                    sName: "ข้อร้องเรียนที่มีนัยสำคัญ",
                    idDiv: 4,
                    imgBase64: image
                }
                arrBase64.push(obj)
            }
            let strHTMLtimeline2 = document.getElementById("timeline_3");
            if (strHTMLtimeline2) {
                let Element = strHTMLtimeline2 as HTMLDivElement;
                let canvas = await html2canvas(Element);
                let image = canvas.toDataURL("image/png", 1.0);
                let obj = {
                    id: 31,
                    sDesc: "timeline2",
                    sName: "ข้อร้องเรียนปกติ",
                    idDiv: 4,
                    imgBase64: image
                }
                arrBase64.push(obj)
            }
        }
        await UnBlockUI();
        await onExportExcel(arrBase64);

    }

    const onExportExcel = async (arrTimeline) => {

        if (ImgChart.length > 0) {
            // if (nCountAllDiv === ImgChart.length) {
            let Param = {
                "lstBA": form.getValues("arrBA") ?? null,
                "lstJobType": form.getValues("arrTypeJob") ?? null,
                "sIssueDateStart": form.getValues("arrDateIssue")[0] ? (moment(form.getValues("arrDateIssue")[0])).format("DD/MM/YYYY") + "" : null,
                "sIssueDateEnd": form.getValues("arrDateIssue")[1] ? (moment(form.getValues("arrDateIssue")[1])).format("DD/MM/YYYY") + "" : null,
                "ImgChart": [...ImgChart,...arrTimeline],
                "lstdataSLA": dataDiv2,
                "dataExistCust": dataExistCust != null ? dataExistCust.lstdataDisplay : null,
                "dataPotentialCust": dataPotentialCust != null ? dataPotentialCust.lstdataDisplay : null,
            }
            let sFileName = `รายงานสรุปสถานะใบคำร้อง_${moment().format("DDMMYYYYHHmmss")}`;
            await AxiosPostFileExcel(`ExportReport/ExportSummaryStatusRequestReport`, Param, sFileName, null, null, BlockUI, UnBlockUI)
            // }
        }
    }

    const ExportFileExcel = async () => {

        await onGetBase64Timeline();

    }

    const onhandleInput = () => {
        setImgChart([]);
    }

    useEffect(() => {
        let gDivpieAVG = document.querySelectorAll('[id^="pie_avg"]');
        let gDivgauge = document.querySelectorAll('[id^="gauge_"]');
        let gDivtimeline = [] // document.querySelectorAll('[id^="timeline_"]');
        let gDivOverlap = document.querySelectorAll('[id^="ba-overlap_"]');
        let gDivbarYear = document.querySelectorAll('[id^="barYear"]');
        let nCountAllDiv = gDivpieAVG.length + gDivgauge.length + gDivtimeline.length + gDivOverlap.length + gDivbarYear.length;
        setnCountAllDiv(nCountAllDiv)

    }, [document.querySelectorAll('[id^="pie_avg"]'), document.querySelectorAll('[id^="gauge_"]'), document.querySelectorAll('[id^="timeline_"]'), document.querySelectorAll('[id^="ba-overlap_"]'), document.querySelectorAll('[id^="barYear"]')])


    return (
        <>
            <InnerHeadRoutes
                iconMUI={<QueryStatsRoundedIcon style={{ fontSize: '1.5em' }} />}
                labal_Head="รายงาน"
                label_nameRoute="สรุปสถานะใบคำร้อง"
            />
            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" style={{ marginTop: '0' }}>
                <Grid item xs={12}>
                    {/* Search */}
                    <FormProvider {...form}>
                        <div className='div-border'>
                            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="start">
                                <Grid item xs={12} sm={6} md={3.5}>
                                    <MultiSelectForm
                                        name="arrBA"
                                        options={optionBA}
                                        label={'กลุ่มตลาด'}
                                        required={false}
                                        onChange={() => { onhandleInput() }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3.5}>
                                    <MultiSelectForm
                                        name="arrTypeJob"
                                        options={optionJobType}
                                        label={'ประเภทใบงาน'}
                                        required={false}
                                        onChange={() => { onhandleInput() }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={5} xl={5}>
                                    <DateRangePicker
                                        label={"วันที่แจ้ง (เริ่มต้น)"}
                                        lableEnd={"วันที่แจ้ง (สิ้นสุด)"}
                                        require={true}
                                        name="arrDateIssue"
                                        onChange={() => { onhandleInput() }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={'auto'}>
                                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                                        <Grid item>
                                            <BtnSearch onClick={form.handleSubmit(() => { onSearchData() })} />
                                        </Grid>
                                        <Grid item>
                                            <BtnExportExcel isDisabled={nCountAllDiv !== ImgChart.length} onClick={() => { ExportFileExcel() }} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                    </FormProvider>
                </Grid>
                {/* <Grid item xs={12} md={4}>
                    <TimelineCustom/>
                </Grid> */}
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={5}>
                            <div className='div-border'>
                                <StatusPieChart
                                    sBA={sBA}
                                    data={dataDiv1}
                                    exportImg={(e) => {
                                        setImgChart(item => [...item, e]);
                                    }}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <div className='div-border'>
                                <TypeComplaintPieChart
                                    sBA={sBA}
                                    data={dataDiv2}
                                    exportImg={(e) => {
                                        setImgChart(item => [...item, e]);
                                    }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <div className='div-border'>
                        <PieStackTypeCustomer
                            sBA={sBA}
                            dataExistCust={dataExistCust}
                            dataPotentialCust={dataPotentialCust}
                            exportImg={(e) => {
                                setImgChart(item => [...item, e]);
                            }}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className='div-border'>
                        <TypeComplaintTimeLineChart
                            sBA={sBA}
                            data={dataDiv3}
                            exportImg={(e) => {
                                setImgChart(item => [...item, e]);
                            }}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className='div-border'>
                        <BAOverlapPieChart
                            sBA={sBA}
                            data={dataDiv4}
                            exportImg={(e) => {
                                setImgChart(item => [...item, e]);
                            }}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className='div-border'>
                        <NumberReqBarChart
                            sBA={sBA}
                            data={dataDiv5}
                            ImgChart={ImgChart}
                            exportImg={(e) => {
                                setImgChart(item => [...item, e]);
                            }}
                        />
                    </div>
                </Grid>
            </Grid>
        </>
    )
}

export default SummaryStatusRequestReport